interface AddressParts {
  address?: string;
  city?: string;
  state?: string;
  zip?: string;
}

/**
 * Formats an address as a string
 */
export default function formatAddress({ address, city, state, zip }: AddressParts): string {
  return address
    ? `${address}${city ? `, ${city}` : ""}${state ? `, ${state}` : ""}${zip ? ` ${zip}` : ""}`
    : "No address";
}
